module.exports = __webpack_public_path__ + "static/heartland-17d4d645c015fcbfc7de2744da8146fb.jpg";